import { Box, ColorOptions, convertHexToRGBA, Icon, Text } from '@jfs/ui-new'
import { TableComponent } from '../../comps/TableComponent'
import { actionMenuStrings } from '../../data/static/strings'
import { INFINITE_SCROLL_WINDOW_INDEX } from '../../util/common'
import { Colors, getSelectedDate } from '../../util/util'

export const AppliedFilters = ({
  updateFilters,
  apply,
  updateMax,
  updateMin,
  updateSelectedFilterDateInfo,
  updateSelectedDateInfo,
  filterList,
}: any) => {
  const listData = filterList ?? []

  const clearFilter = (item) => {
    updateSelectedDateInfo({
      fromDate: getSelectedDate(INFINITE_SCROLL_WINDOW_INDEX),
      toDate: new Date(Date.now()),
      position: {
        top: 0,
        left: 0,
        visible: false,
      },
      dateLabel: actionMenuStrings?.infiniteScrollRange,
    })
    if (item?.key === 'amountRange') {
      updateMin('')
      updateMax('')
    } else if (item?.key === 'min') {
      updateMin('')
    } else if (item?.key === 'max') {
      updateMax('')
    } else if (item?.key === 'selectedDateInfo') {
      updateSelectedFilterDateInfo({ fromDate: '', toDate: '', dateLabel: '' })
    } else {
      updateFilters(item.key, item.value)
    }
    apply()
  }
  const renderAppliedFilterViews = ({ item, index }) => {
    return (
      <Box
        flexDirection={'row'}
        pl={12}
        pv={6}
        pr={8}
        gap={8}
        ml={index === 0 ? 24 : 0}
        borderRadius={100}
        bg={convertHexToRGBA(Colors.PRIMARY, 12) as ColorOptions}
        marginVertical={8}
        marginRight={12}
        underlayColor={'TRANSPARENT'}
        testID="clear-filter"
        onPress={() => clearFilter(item)}>
        <Text
          title={item?.value}
          fontFamily={'JioType-Medium'}
          fontSize={12}
          lineHeight={16}
          color={Colors.BLACK_14 as ColorOptions}
          letterSpacing={-0.06}
        />
        <Icon id={'CLEAR'} color={'PRIMARY'} size={16} />
      </Box>
    )
  }
  return (
    <Box bg={'WHITE'}>
      <TableComponent
        ListContent={listData}
        RenderCustomElement={renderAppliedFilterViews}
        isCustom={true}
        value={''}
        horizontal
      />
    </Box>
  )
}
